import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";

function ResourceBar(props) {
  let text = "";
  let variant = "";
  let maxValue = props.maxValue ? props.maxValue : 100;
  let curValue = props.curValue ? props.curValue : 0;
  if (props.type === "health") {
    text = "HP:";
    variant = "danger";
  } else if (props.type === "mana") {
    text = "MP:";
    variant = "";
  } else if (props.type === "action") {
    text = "AP:";
    variant = "warning";
  }

  return (
    <div>
      <Row>
        <Col md={3}>{text}</Col>
        <Col md={7}>{"".concat(curValue, "/", maxValue)}</Col>
      </Row>
      <Row>
        <Col>
          <ProgressBar
            now={(curValue / maxValue) * 100}
            className=""
            variant={variant}
          />
        </Col>
      </Row>
    </div>
  );
}

export default ResourceBar;
